module.exports = __webpack_public_path__ + "static/fizosteo-opengraph-014363e45e6d2ad1f4641a570fe1266a.png";